module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XFPRlL/tc-custom/9781488004445.jpg?1728259408074",
      "alt": "This image is the cover for the book Once Upon a Regency Christmas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Once Upon a Regency Christmas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("THREE REGENCY HEROES IN DISGUISE. ")]), _c('br'), _c('br'), _c('b', [_vm._v("THREE CHRISTMAS NOVELLAS TO WARM YOUR HEART! ")]), _c('br'), _c('br'), _c('b', [_vm._v("ON A WINTER'S EVE by Louise Allen ")]), _c('br'), _c('br'), _vm._v("Snowbound together, Lady Julia Chalcott and Captain Giles Markham try to fight temptation. But, as Christmas draws closer, their attraction proves too strong to resist! "), _c('br'), _c('br'), _c('b', [_vm._v("MARRIAGE MADE AT CHRISTMAS by Sophia James ")]), _c('br'), _c('br'), _vm._v("Christine Howard's frozen heart melts as she gets to know her new bodyguard. How can a man so scarred and mysterious make her feel so safe? "), _c('br'), _c('br'), _c('b', [_vm._v("CINDERELLA'S PERFECT CHRISTMAS by Annie Burrows ")]), _c('br'), _c('br'), _vm._v("Shy Alice Waverly's kiss with Captain Jack Grayling makes her wonder if heand his little childrencould be the Christmas miracle she's always dreamed of\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Louise Allen, Sophia James, Annie Burrows\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0